// apiHealth.ts - v11.8.6.0
// Global API-availability signal (framework-agnostic, no React dependency so lib/ stays clean).
//
// The fetch wrapper in api.ts reports a "suspect outage" whenever an API call returns HTTP 503
// (IIS returns 503 when the API app pool is stopped, e.g. during a deploy) or the fetch itself
// network-rejects (host unreachable / CORS-less error from a stopped pool). The maintenance
// overlay (useApiHealth) subscribes, CONFIRMS via /healthz, shows a branded "be right back"
// screen while down, and auto-recovers when /healthz returns.

type Listener = () => void;

const suspectListeners = new Set<Listener>();

/** Called by api.ts when a request looks like the API is down (503 or network failure). */
export function reportApiSuspect(): void {
  for (const l of suspectListeners) {
    try { l(); } catch { /* a listener throwing must not break the caller */ }
  }
}

/** Subscribe to suspected-outage signals. Returns an unsubscribe function. */
export function onApiSuspect(listener: Listener): () => void {
  suspectListeners.add(listener);
  return () => { suspectListeners.delete(listener); };
}
